// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7ludS":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "90Lbo": "swiper.8e432e94.js",
    "9lnFG": "swiper.68827f69.js",
    "482A8": "modules.01e38241.js",
    "l2Jfz": "swiper.2be5e59a.css"
});

},{}],"dyWE2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _heroTextImageScss = require("./hero_text_image.scss");
var _slider = require("../js/slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
const swiperSelectorString = "section.hero .swiper";
const options = {
    spaceBetween: 20,
    autoHeight: false,
    slidesPerView: 1,
    rewind: true,
    // centeredSlides: true,
    grabCursor: true
};
console.log({
    swiper: (0, _sliderDefault.default),
    options
});
(0, _sliderDefault.default)(swiperSelectorString, options);

},{"./hero_text_image.scss":"iWaV0","../js/slider":"gufdI","@parcel/transformer-js/src/esmodule-helpers.js":"9ZthI"}],"iWaV0":[function() {},{}],"gufdI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
async function initializeSwiper(swiperSelectorString, options) {
    const swiperCollection = document.querySelectorAll(swiperSelectorString);
    console.log({
        swiperCollection,
        swiperSelectorString
    });
    console.log({
        options
    }, `${swiperSelectorString} .swiper-button-next`);
    if (swiperCollection.length > 0) {
        const { Swiper } = await require("bd66b797af2dbb7c");
        const { Navigation, Autoplay } = await require("62f247f457a6bec2");
        await require("7be487440ead5396");
        options = Object.assign(options, {
            modules: [
                Navigation,
                Autoplay
            ],
            navigation: {
                nextEl: `${swiperSelectorString} .swiper-button-next`,
                prevEl: `${swiperSelectorString} .swiper-button-prev`
            }
        });
        // await import("/node_modules/swiper/modules/navigation.css");
        console.log({
            swiperCollection
        });
        swiperCollection.forEach((swiper, i)=>{
            console.log(`${swiper} img`);
            const image = swiper.querySelector(`img`);
            const li = swiper.querySelector(`li`);
            const liHeight = swiper.scrollHeight;
            const caption = swiper.querySelector(`.caption`);
            // console.log(
            //     image.scrollHeight,
            //     caption.getBoundingClientRect().height,
            // );
            const imageHeight = liHeight - caption?.getBoundingClientRect().height;
            const navigator = swiper.querySelector(".swiper-nav");
            // console.log({
            //     swiper,
            //     image,
            //     navigator,
            //     caption,
            //     swiper,
            //     imageHeight,
            // });
            // navigator.style.bottom = `${imageHeight}px`;
            const cards = Array.from(swiper.querySelectorAll(".card"));
            const wrapper = swiper.querySelector(".swiper-wrapper");
            console.log(cards.length);
            if (cards.length && cards.length < 5) {
                let counter = 1;
                let childLength = document.querySelectorAll(swiperSelectorString)[i]?.querySelector(".swiper-wrapper").childElementCount;
                while(childLength < 10){
                    console.log(cards);
                    const clonedElement = cards[counter - 1].cloneNode(true);
                    clonedElement.setAttribute("aria-hidden", "true");
                    wrapper.appendChild(clonedElement);
                    childLength = document.querySelectorAll(swiperSelectorString)[i]?.querySelector(".swiper-wrapper").childElementCount;
                    if (counter == cards.length) counter = 1;
                    else counter++;
                }
            }
            swiper = swiper.parentElement.querySelector(".swiper");
            console.log(swiper.querySelector(".swiper-wrapper").childElementCount);
            const swiperInstance = new Swiper(swiper, options);
            console.log(swiperInstance);
        });
    }
}
exports.default = initializeSwiper;

},{"bd66b797af2dbb7c":"21OL2","62f247f457a6bec2":"1wQET","7be487440ead5396":"7wXH0","@parcel/transformer-js/src/esmodule-helpers.js":"9ZthI"}],"21OL2":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("fc3c9ed38f553143")(module.bundle.resolve("9lnFG")),
    require("fc3c9ed38f553143")(module.bundle.resolve("90Lbo"))
]).then(()=>module.bundle.root('ibI2U'));

},{"fc3c9ed38f553143":"cshMD"}],"cshMD":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"i1Mkl"}],"i1Mkl":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"1wQET":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("7d45b7166e401733")(module.bundle.resolve("9lnFG")),
    require("7d45b7166e401733")(module.bundle.resolve("482A8"))
]).then(()=>module.bundle.root('2puor'));

},{"7d45b7166e401733":"cshMD"}],"7wXH0":[function(require,module,exports,__globalThis) {
module.exports = require("a96ee2561beadcef")(module.bundle.resolve("l2Jfz"));

},{"a96ee2561beadcef":"lLjr5"}],"lLjr5":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"i1Mkl"}],"9ZthI":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["7ludS","dyWE2"], "dyWE2", "parcelRequireacc4", {}, "../", "/wp-content/themes/applfm/")

//# sourceMappingURL=hero_text_image.js.map
